import React from 'react';
import { withApollo } from "react-apollo";
import { withRouter } from 'react-router';

import { mails } from '../../graphql/queries';
import { deleteAllMail } from '../../graphql/mutations';

class DeleteAllMail extends React.Component {

    deleteAll = () => {

        const confirm = window.confirm('This will delete ALL mail and cannot be undone, y\'know?');
        if (!confirm) return;

        this.props.client.mutate({
            mutation: deleteAllMail,
            variables: {},
            refetchQueries: [{ query: mails }]
        })
            .then(res => {
                this.props.history.replace('/mails/');
            })
            .catch(e => {
                alert('Delete All Mail Error: ' + e);
            });
    }

    render() {
        return (
            <button className="col__action col__action--danger" onClick={this.deleteAll}>Delete All</button>
        );
    }
}


export default withRouter(withApollo(DeleteAllMail))


// WEBPACK FOOTER //
// ./src/components/mail/MailDeleteAll.js